<template>
  <section class="menu" :class="{'no-mobile': isChat}">
    <a class="logo" href="/">
      <img src="@/assets/images/mini-logo.webp" />
    </a>
    <div
      @click="changeState('panel')"
      v-if="getUser"
      class="menu-user"
      :style="{ backgroundImage: 'url(' + getAvatar + ')' }"
    >
      <div class="nav-item__notif" v-if="getNotifications && getNotifications.all">
        <p>{{ getNotifications.all }}</p>
      </div>
    </div>
    <div @click="openWorkplace()" class="menu-add">
      <img src="@/assets/images/icons/icon_plus.svg" />
    </div>
    <nav class="nav">
      <!-- <div class="nav__line" :style="{top: lineActive}"></div> -->
      <ul class="nav-list">
        <router-link tag="li" class="nav-item" to="/lenta" :disabled="true">
          <div class="nav-item__icon">
            <svg aria-hidden="true" role="img" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" ><path class="fill" d="M216 24.01c0-23.8-31.16-33.11-44.15-13.04C76.55 158.25 200 238.73 200 288c0 22.06-17.94 40-40 40s-40-17.94-40-40V182.13c0-19.39-21.85-30.76-37.73-19.68C30.75 198.38 0 257.28 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-192.85-168-295.99zM192 480c-88.22 0-160-71.78-160-160 0-46.94 20.68-97.75 56-128v96c0 39.7 32.3 72 72 72s72-32.3 72-72c0-65.11-112-128-45.41-248C208 160 352 175.3 352 320c0 88.22-71.78 160-160 160z" ></path></svg>
          </div>
          <div class="nav-item__desc">
            <p>Лента</p>
          </div>
        </router-link>
        
        <router-link tag="li" class="nav-item" to="/events">
              <div class="nav-item__icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="width-2" width="25" height="25" fill="none" viewBox="0 0 24 24">
                  <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.27 14.952l1.593-5.09 5.089-1.592-1.593 5.09-5.089 1.592z" clip-rule="evenodd"/>
                  <circle cx="11.611" cy="11.611" r="9.611" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </svg>
                <div class="nav-item__notif" v-if="getNotifications && getNotifications.invites">
                  <p>{{ getNotifications.invites }}</p>
                </div>
              </div>
              <div class="nav-item__desc">
                <p>Ивенты</p>
              </div>
        </router-link>
        <router-link tag="li" class="nav-item no-mobile" :to="{name: 'places'}" >
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24">
            <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.5 10.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z" clip-rule="evenodd"/>
            <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c-1.199 0-7.5-5.102-7.5-10.437C4.5 6.387 7.857 3 12 3c4.142 0 7.5 3.387 7.5 7.563C19.5 15.898 13.198 21 12 21z" clip-rule="evenodd"/>
          </svg>
          <div class="nav-item__desc">
            <p>Места</p>
        </div>
        </router-link>
        <router-link tag="li" class="nav-item no-mobile" to="/users">
          <div class="nav-item__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.592 15.207c3.688 0 6.841.559 6.841 2.792 0 2.233-3.131 2.808-6.841 2.808-3.69 0-6.842-.554-6.842-2.788s3.13-2.812 6.842-2.812zM9.592 12.02a4.386 4.386 0 114.385-4.385 4.37 4.37 0 01-4.354 4.385h-.031z" clip-rule="evenodd"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.483 10.882A3.301 3.301 0 0019.32 7.62a3.3 3.3 0 00-2.762-3.256M18.596 14.732c1.55.231 2.634.775 2.634 1.895 0 .771-.51 1.271-1.335 1.584"/>
            </svg>
            <div class="nav-item__notif" v-if="getNotifications && getNotifications.offers">
              <p>{{ getNotifications.offers }}</p>
            </div>
          </div>
          <div class="nav-item__desc">
            <p>Райдеры</p>
          </div>
        </router-link>

        <router-link tag="li" class="nav-item" to="/messages">
          <div class="nav-item__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.903 8.851l-4.444 3.613c-.84.666-2.02.666-2.86 0L6.12 8.851"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.909 21C19.95 21.008 22 18.51 22 15.438V8.57C22 5.499 19.95 3 16.909 3H7.09C4.05 3 2 5.499 2 8.57v6.868C2 18.51 4.05 21.008 7.091 21h9.818z" clip-rule="evenodd"/>
            </svg>
            <div
            class="nav-item__notif"
            v-if="
              getNotifications && getNotifications.messages && getNotifications.messages.chats && getNotifications.messages.chats > 0
            ">
              <p>{{ getNotifications.messages.chats }}</p>
            </div>
          </div>
          <div class="nav-item__desc">
            <p>Чаты</p>
          </div>
        </router-link>
        
        <router-link tag="li" class="nav-item no-mobile" to="/shop">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path class="stroke" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.75 3.25l2.08.36.963 11.473a1.8 1.8 0 001.8 1.653h10.91a1.8 1.8 0 001.784-1.546l.95-6.558a1.341 1.341 0 00-1.136-1.52C20.037 7.105 5.164 7.1 5.164 7.1M14.125 10.795h2.773"/>
            <path class="fill" fill="#130F26" fill-rule="evenodd" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.154 20.203a.544.544 0 110 1.087.544.544 0 010-1.087zM18.435 20.203a.545.545 0 110 1.09.545.545 0 010-1.09z" clip-rule="evenodd"/>
          </svg>
          <div class="nav-item__desc">
            <p>Снаряжение</p>
          </div>
        </router-link>
        <li class="nav-item nav-item_colored no-mobile" @click="openCharityModal()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke-width="0" viewBox="0 0 24 24">
            <path fill="#130F26" d="M11.776 21.837a36.258 36.258 0 01-6.328-4.957 12.668 12.668 0 01-3.03-4.805C1.278 8.535 2.603 4.49 6.3 3.288A6.282 6.282 0 0112.007 4.3a6.291 6.291 0 015.706-1.012c3.697 1.201 5.03 5.247 3.893 8.787a12.67 12.67 0 01-3.013 4.805 36.58 36.58 0 01-6.328 4.957l-.25.163-.24-.163z" opacity=".4"/>
            <path fill="#130F26" d="M12.01 22l-.234-.163a36.316 36.316 0 01-6.337-4.957 12.667 12.667 0 01-3.048-4.805c-1.13-3.54.195-7.586 3.892-8.787a6.296 6.296 0 015.728 1.023V22zM18.23 10a.719.719 0 01-.517-.278.818.818 0 01-.167-.592c.022-.702-.378-1.341-.994-1.59-.391-.107-.628-.53-.53-.948.093-.41.477-.666.864-.573a.384.384 0 01.138.052c1.236.476 2.036 1.755 1.973 3.155a.808.808 0 01-.23.56.708.708 0 01-.537.213z"/>
          </svg>
          <div class="nav-item__desc">
            <p>Поддержка</p>
          </div>
        </li>
        <!-- <li class="nav-item no-mobile" @click="changeState('theme')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke-width="0" viewBox="0 0 24 24">
            <path fill="#130F26" d="M11.776 21.837a36.258 36.258 0 01-6.328-4.957 12.668 12.668 0 01-3.03-4.805C1.278 8.535 2.603 4.49 6.3 3.288A6.282 6.282 0 0112.007 4.3a6.291 6.291 0 015.706-1.012c3.697 1.201 5.03 5.247 3.893 8.787a12.67 12.67 0 01-3.013 4.805 36.58 36.58 0 01-6.328 4.957l-.25.163-.24-.163z" opacity=".4"/>
            <path fill="#130F26" d="M12.01 22l-.234-.163a36.316 36.316 0 01-6.337-4.957 12.667 12.667 0 01-3.048-4.805c-1.13-3.54.195-7.586 3.892-8.787a6.296 6.296 0 015.728 1.023V22zM18.23 10a.719.719 0 01-.517-.278.818.818 0 01-.167-.592c.022-.702-.378-1.341-.994-1.59-.391-.107-.628-.53-.53-.948.093-.41.477-.666.864-.573a.384.384 0 01.138.052c1.236.476 2.036 1.755 1.973 3.155a.808.808 0 01-.23.56.708.708 0 01-.537.213z"/>
          </svg>
          <div class="nav-item__desc">
            <p>Поддержка</p>
          </div>
        </li> -->
        <div tag="li" class="nav-item only-mobile" @click="openPanel()" v-if="!getUser">
          <div class="nav-item__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.157 19.771v-3.066c0-.78.636-1.414 1.424-1.42h2.886c.792 0 1.433.636 1.433 1.42v3.076c0 .662.534 1.204 1.203 1.219h1.924c1.918 0 3.473-1.54 3.473-3.438v0-8.724a2.44 2.44 0 00-.962-1.905l-6.58-5.248a3.18 3.18 0 00-3.945 0L2.462 6.943A2.42 2.42 0 001.5 8.847v8.715C1.5 19.46 3.055 21 4.973 21h1.924c.685 0 1.241-.55 1.241-1.229v0"/>
            </svg>
            <span class="nav-item__notif" v-if="getNotifications && getNotifications.all">{{ getNotifications.all }}</span>
          </div>
          <div class="nav-item__desc">
            <p>Меню</p>
          </div>
        </div>
        <li class="nav-item" v-if="getUser">
         <div
          @click="openPanel()"
          class="menu-user menu-user_mobile"
          :style="{ backgroundImage: 'url(' + getAvatar + ')' }"
        ></div>
        </li>
      </ul>
    </nav>
    <div class="menu-pallete" @click="changeState('theme')">
    </div>
  </section>
</template>

<script>
import charity from "@/data/main/charity"

export default {
  data() {
    return {
      panel: false,
      posting: false,
      line: 0,
    };
  },
  computed: {
    isChat() {
      let route = this.$route.name;
      return (route == 'chat' || route == 'messages') && !this.$store.getters.chat_list
    },
    getNotifications() {
      return this.$store.getters.getUserNotifications;
    },
    getUser() {
      return this.$store.getters.getAuthUser;
    },
    getAvatar() {
      let user = this.getUser;
      return user ? user.avatar : '';
    },
    lineActive() {
      let name = this.$route.name;
      let top;
      if (name === 'events' || name === 'event') {
        top = '72px';
      } else if (
        name === 'users' ||
        name === 'profile' ||
        name === 'friends' ||
        name === 'offers' ||
        name === 'myoffers'
      ) {
        top = '133px';
      } else if (name === 'messages') {
        top = '193px';
      } else if (name === 'places') {
        top = '253px';
      } else if (name === 'shop') {
        top = '270px';
      } else {
        top = '72px';
      }
      return top;
    },
  },
  watch: {
    $route() {
      this.getUser ? this.$store.dispatch('notifications', { user: this.getUser.id }) : '';
    },
  },
  methods: {
    openPanel() {
      this.getUser ? this.changeState('panel') : this.$router.push({name: 'registration'})
    },
    openWorkplace() {
      this.getUser ? this.changeState('workplace') : this.$router.push({name: 'registration'})
    },
    changeState(element) {
      this.$store.dispatch('changeState', { element });
    },
    openCharityModal() {
      this.$store.dispatch('setModal', charity )
    }
  }
};
</script>
